export default __webpack_public_path__ + "static/media/login-embelishment-1.bdb7296a.svg";